import { render, staticRenderFns } from "./CustomPointTable.vue?vue&type=template&id=d12c73ee"
import script from "./CustomPointTable.vue?vue&type=script&lang=js"
export * from "./CustomPointTable.vue?vue&type=script&lang=js"
import style0 from "./CustomPointTable.vue?vue&type=style&index=0&id=d12c73ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports